export var DataTestAttributes = /*#__PURE__*/function (DataTestAttributes) {
  DataTestAttributes["COUPON_WRAPPER"] = "COUPON_WRAPPER";
  DataTestAttributes["MESSAGE_BOX"] = "MESSAGE-BOX";
  DataTestAttributes["MESSAGE_BOX_TEXT"] = "MESSAGE-BOX-TEXT";
  DataTestAttributes["ORDER_PREVIEW_WRAPPER"] = "ORDER_PREVIEW_WRAPPER";
  DataTestAttributes["ORDER_SUMMARY"] = "ORDER_SUMMARY";
  DataTestAttributes["ORDER_SUMMARY_WRAPPER"] = "ORDER_SUMMARY_WRAPPER";
  return DataTestAttributes;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/constants/DataTestAttributes.js
// module id = 666
// module chunks = 11